import BillingV2Adapter from './billing-v2';

export default class LocationSubscriptionAdapter extends BillingV2Adapter {
  pathForType() {
    return 'subscriptions';
  }
}
